<template>
<div class="chapter">
<div class="inner_page">
<span epub:type="pagebreak" id="page5" title="5">
<figure>
<img alt="To Nelly" class="fullpage" id="page005_001" src="images/page005_01.jpg"/>
</figure>
</span>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// page005.vue?c95473ca